import * as React from "react"
import Svg, { Path } from "react-native-svg"

const GiftIconClosed = (props) => {
  return (
    <Svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M16.5 9.22v7.5c0 .72-.592 1.313-1.313 1.313H9.564v-8.25H8.437v8.25H2.814c-.72 0-1.313-.592-1.313-1.312v-7.5c0-.308.255-.563.563-.563h13.874c.308 0 .563.255.563.563z"
        fill="#D32F2F"
      />
      <Path
        d="M18 6.596V8.47c0 .72-.593 1.312-1.313 1.312H1.313C.593 9.783 0 9.191 0 8.471V6.596c0-.72.593-1.313 1.313-1.313h15.374c.72 0 1.313.593 1.313 1.313z"
        fill="#F44336"
      />
      <Path
        d="M9 6.066a.564.564 0 01-.556-.645C8.72 3.546 10.185 0 13.746 0 15.778 0 16.5 1.098 16.5 2.038c0 1.672-2.328 4.028-7.5 4.028zm4.746-4.941c-2.686 0-3.706 2.554-4.044 3.8 2.12-.1 3.456-.636 4.225-1.092 1.068-.634 1.448-1.343 1.448-1.795 0-.674-.841-.913-1.629-.913z"
        fill="#FFC107"
      />
      <Path
        d="M9.001 6.066c-5.174 0-7.5-2.356-7.5-4.027C1.501 1.098 2.222 0 4.255 0c3.56 0 5.025 3.546 5.302 5.421a.564.564 0 01-.556.645zM4.255 1.125c-.788 0-1.629.24-1.629.913 0 .958 1.675 2.703 5.673 2.887-.338-1.246-1.358-3.8-4.044-3.8z"
        fill="#FFC107"
      />
      <Path d="M9.563 9.783v8.25H8.437v-8.25h1.126z" fill="#FF8F00" />
      <Path
        d="M9.563 5.726v4.057H8.437V5.726c0-.172.06-.33.158-.443A.558.558 0 019 5.096c.158 0 .3.075.405.187.098.113.158.27.158.443z"
        fill="#FFC107"
      />
      <Path
        d="M8.438 9.783H1.5v6.938c0 .72.592 1.312 1.313 1.312h5.624v-8.25z"
        fill="#B82929"
      />
      <Path
        d="M4.474 5.283H1.313C.593 5.283 0 5.876 0 6.596V8.47c0 .72.593 1.312 1.313 1.312h7.125V6.056c-1.615-.055-2.93-.348-3.964-.773z"
        fill="#D43A2F"
      />
      <Path
        d="M4.255 1.125c-.788 0-1.629.24-1.629.913 0 .958 1.675 2.703 5.673 2.887-.338-1.246-1.358-3.8-4.044-3.8z"
        fill="#DEDEDE"
      />
      <Path
        d="M8.298 4.925C4.301 4.74 2.625 2.995 2.625 2.038c0-.674.842-.914 1.63-.914 2.686.001 3.706 2.555 4.043 3.8zM4.255 0C2.222 0 1.501 1.098 1.501 2.038c0 1.067.946 2.411 2.974 3.245 1.034.425 2.349.718 3.963.773v-.33c0-.172.06-.33.157-.443A.558.558 0 019 5.095V3.51C8.262 1.797 6.79 0 4.255 0z"
        fill="#DEA806"
      />
      <Path d="M9 9.783h-.563v8.25H9v-8.25z" fill="#DE7C00" />
      <Path
        d="M9 5.096c-.158 0-.3.075-.405.187a.677.677 0 00-.158.443V9.783H9V5.096z"
        fill="#DEA806"
      />
    </Svg>
  )
}

export default GiftIconClosed
